import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5"; 
import { FiDownload } from "react-icons/fi"; 

function NameHistory({ isSubScribe, data }) {
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // Extract unique financial years from data
  const getFinancialYears = () => {
    return [...new Set(data.map((row) => row.financialYear))].sort((a, b) => b - a); 
  };

  // Update selected financial year when data changes
  useEffect(() => {
    const years = getFinancialYears();
    if (years.length > 0) {
      setSelectedFinancialYear(years[0]); // Default to the latest financial year
    }
  }, [data]);

  // Filter data based on selected financial year
  useEffect(() => {
    if (selectedFinancialYear) {
      const filtered = data.filter((row) => row.financialYear === selectedFinancialYear);
      setFilteredData(filtered);
    }
  }, [selectedFinancialYear, data]);

  const toggleTable = () => {
    if (!isSubScribe) {
      alert("Please unlock to see the data.");
      return;
    }
    setIsTableOpen((prevState) => !prevState);
  };

  const noDataAvailable = !isSubScribe || filteredData.length === 0;

  return (
    <div className={styles.table_subcontainer}>
      <div>
        {isSubScribe && (
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={toggleTable}>
              {isTableOpen ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>
              {/* Name History -  31 Mar, {selectedFinancialYear || "All"} */}
              Name History 
  {filteredData.length > 0 && selectedFinancialYear && ` - 31 Mar, ${selectedFinancialYear}`}
  {filteredData.length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  value={selectedFinancialYear}
                  onChange={(e) => setSelectedFinancialYear(e.target.value)}
                >
                  {getFinancialYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
  )}
            </h3>
          </div>
        )}

        {isTableOpen && (
          <>
            {!isSubScribe && (
              <button className={styles.Subscription_msg}>
                <IoMdLock /> Subscription required to view data
              </button>
            )}

            {isSubScribe && (
              <table className={styles.commantable}>
                <thead>
                  <tr className={styles.tableHeaderRow}>
                    <th className={styles.tableHeader}>S.No</th>
                    <th className={styles.tableHeader}>EXISTING NAME</th>
                    <th className={styles.tableHeader}>NEW NAME</th>
                    <th className={styles.tableHeader}>EFFECTIVE DATE</th>
                    <th className={styles.tableHeader}>Reference DOCUMENTS</th>
                  </tr>
                </thead>
                <tbody>
                  {noDataAvailable ? (
                    <tr>
                      <td colSpan="5" className={styles.noDataMessage} style={{textAlign:"center"}}>
                        No Name History Data Available.
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((row, index) => (
                      <tr key={row.Id} className={styles.tableRow}>
                        <td className={styles.tableCell}>{index + 1}</td>
                        <td className={styles.tableCell}>{row.exist_name || "-"}</td>
                        <td className={styles.tableCell}>{row.name || "-"}</td>
                        <td className={styles.tableCell}>
                          {row.tillDate
                            ? new Date(row.tillDate).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : ""}
                        </td>
                        <td className={styles.tableCell}>
                          {row.referenceDoc && row.referenceDoc.length > 0 ? (
                            row.referenceDoc.map((doc, index) => (
                              <div key={index}>
                                <a 
                                  href={doc.fileurl} 
                                  target="_blank" 
                                  rel="noopener noreferrer" 
                                  style={{ color: "#2961EF", textDecoration: "none" }}
                                >
                                  {doc.Name}
                                </a>
                              </div>
                            ))
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default NameHistory;
